<script>
    import ButtonNormal from '@/components/buttons/ButtonNormal.vue';
    import NumberPicker from '../../shared/NumberPicker';

    export default {
        name: 'WizardAdminSecondStep',
        components: {NumberPicker, ButtonNormal},
        props: {
            title: String,
            description: String,
            image: String,
            customData: Array,
        },
        data() {
            return {
                selectedNumber: null,
                isValid: false,
            };
        },
        watch: {
            selectedNumber(val) {
                this.isValid = val !== null;
            },
        },
        methods: {
            getImage(name) {
                const images = require.context(
                    '../../../assets/wizard',
                    false,
                    /\.svg$/,
                );
                return images('./' + name + '.svg');
            },
        },
    };
</script>

<template>
    <div class="wizard-content-step">
        <div class="wizard-content-header">
            <div class="description">
                <h1>{{title}}</h1>
                <p v-html="description"></p>
            </div>
        </div>
        <div class="blocks">
            <div class="block">
                <div class="image">
                    <img :src="getImage(image)" atl="Wizard image"/>
                </div>
            </div>
            <div class="block grid-column-2">
                <div class="numbers">
                    <NumberPicker :numbers="customData" :max-height="'175px'" v-model="selectedNumber"/>
                </div>
            </div>
        </div>
        <div class="blocks">
            <div class="actions grid-column-1 right" >
                <ButtonNormal @onClick="() => this.$emit('on_prev','')" class="right" buttonTitle="Zurück"
                              cssClass="btn btn-secondary"/>
            </div>
            <div class="actions grid-column-2">
                <ButtonNormal @onClick="() => this.$emit('on_next', selectedNumber)" class="left"
                              buttonTitle="Weiter" cssClass="btn btn-primary" :disabled="!isValid"/>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../assets/scss/variables.scss';
    @import './step.scss';
</style>
